import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  validateOrgResponse: null,
  addOrgData: null,
  getOrgData: null
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.RESET_ALL_STATE:
      return axiosPayLoad;
    case actionTypes.VALIDATE_ORG:
         return {...state, validateOrgResponse: action.validateOrgResponse };
         case actionTypes.ADD_ORGANIZATION:
         return {...state, addOrgData: action.addOrgData };
         case actionTypes.GET_ORGANIZATION:
          return {...state, getOrgData: action.getOrgData };
         case actionTypes.UPDATE_USER_ROLES:
      return {...state, updateUserRoles: action.updateUserRoles, updateRolesTime: new Date };
    default: return state;
  }
};

export default reducer;
